import React from 'react'
import createIcon from '@/lib/create-icon'

export const KeySVGIcon = createIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" viewBox="0 0 19 18" fill="none">
    <path d="M16.8334 1L15.1668 2.66666M8.82432 9.00909C9.65374 9.83851 10.1667 10.9843 10.1667 12.25C10.1667 14.7813 8.11472 16.8333 5.58342 16.8333C3.05211 16.8333 1.00008 14.7813 1.00008 12.25C1.00008 9.71869 3.05211 7.66667 5.58342 7.66667C6.84907 7.66667 7.9949 8.17967 8.82432 9.00909ZM8.82432 9.00909L12.2501 5.58333M12.2501 5.58333L14.7501 8.08333L17.6667 5.16666L15.1668 2.66666M12.2501 5.58333L15.1668 2.66666" stroke="currentColor" strokeOpacity="0.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>,
)
